import { Entity, EntityTypes } from "api/generated"

const isProvider = (entity?: Entity | null) =>
  entity?.entityType !== null &&
  (entity?.entityType === EntityTypes.IAMCLOUD ||
    entity?.entityType === EntityTypes.DISTRIBUTOR ||
    entity?.entityType === EntityTypes.PARTNER)

export { isProvider }
